import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { MenuItem } from 'primeng';
import { AccessUserInfo } from 'src/app/models';
import { MenuDataService } from 'src/app/services/menu-data.service';
import { DialogService } from 'primeng/dynamicdialog';
import { CreateLabRequestComponent } from 'src/app/components/waterLab/request/create-lab-request/create-lab-request.component';
import { CustomDialogService, LabRequestService, UserService } from 'src/app/services';
import { ScreenName, UserActionDescription } from 'src/app/enum/user/userActionDescription';
import { UserAction } from 'src/app/enum/user/userActions';

@Component({
  selector: 'bart-labs-menu',
  templateUrl: './labs-menu.component.html',
  styleUrls: ['./labs-menu.component.scss'],
  providers: [DialogService, CustomDialogService],

})

export class LabsMenuComponent implements OnInit {
  userDetail: any = null;
  public bartRoleCode: string = "";
  public activeLink = '/administrator/ServiceRequest';
  items: MenuItem[];
  showHelp: boolean;
  displayResouceSearch: boolean;
  constructor(private router: Router, private _menuService: MenuDataService, public dialogService: CustomDialogService, private _waterLabService: LabRequestService, private _userService: UserService) { }

  ngOnInit() {
    this.activeLink = this.router.url;
    this.userDetail = AccessUserInfo.getUserInfo();
    this.bartRoleCode = this.userDetail.bartRoleCode;
    this.items = this._menuService.getLabsSubMenuList(this.userDetail.bartRoleCode);    
  }
  navigateToPage(event, url: string) {
    event.preventDefault();
    this.router.navigateByUrl('/', { skipLocationChange: true })
      .then(() => this.router.navigate([url]));
  }
  openCreateLabRequestPopup() {
    const ref = this.dialogService.open(CreateLabRequestComponent, {
      header: 'Create Lab Request',
      width: '70%',
      data: { labRequestId: null }
    })
    ref.onClose.subscribe(ref => {
      this._waterLabService.emitEvent({ foo: 'RefreshGrid' });
    });
    //#region User Action Audit
    this._userService.logUserAction({
      userName: this.userDetail.userName,
      userAction: UserAction.LINK_CLICKED,
      screenName: ScreenName.LABREQUEST,
      screenPath: location.pathname,
      key: 'Create_Lab_Request',
      value: '',
      eventDescription:UserActionDescription.LABREQUEST_CREATE_NEW_REQUEST_LINK_CLICKED
    });
    //#endregion
  }

  openResourcesHelpPopup() {
    this._waterLabService.pushValueFromHelp(true);
    this.displayResouceSearch = true
//#region User Action Audit
    this._userService.logUserAction({
      userName: this.userDetail.userName,
      userAction: UserAction.LINK_CLICKED,
      screenName: ScreenName.LABREQUEST,
      screenPath: location.pathname,
      key: 'Help_Navigation',
      value: '',
      eventDescription:UserActionDescription.LABRESOURCE_HELP_LINK_CLICKED
    });
    //#endregion
  }
  handleClose(e) {
    this.displayResouceSearch = false;
    // this.index=1
    // e.close();
  }
  ngDoCheck() {
    this.activeLink = this.router.url;
    if(this.activeLink=="/WaterLab")
    {
      this.activeLink="/WaterLab"
    }
  }  
}
